module.exports = __webpack_public_path__ + "static/img/banner.dadd7aa.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.jpeg
// module id = 253
// module chunks = 18